import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { ScreenShell, Headline, Subtext } from '../components/ScreenShell';
import { PrimaryButton } from '../components/ui/PrimaryButton';
interface FinalScreenProps {
  childName: string;
  email: string;
  onFinish: () => void;
}
const TIMELINE = [{
  label: 'Perfil recibido',
  state: 'done' as const
}, {
  label: 'Creación personalizada',
  state: 'active' as const
}, {
  label: 'Preparación de audios',
  state: 'todo' as const
}, {
  label: 'Revisión',
  state: 'todo' as const
}, {
  label: 'Entrega por correo',
  state: 'todo' as const
}];
export function FinalScreen({
  childName,
  email,
  onFinish
}: FinalScreenProps) {
  return <ScreenShell data-id="element-67" data-mp="229ll1kxaypta">
      <motion.span initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      type: 'spring',
      stiffness: 200,
      damping: 18
    }} className="inline-flex w-fit items-center gap-2 rounded-full bg-violet-500/10 px-4 py-2 text-sm font-semibold text-violet-700" data-id="element-68" data-mp="2293iy7nylhdg">
        <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-69" data-mp="lejnqy2umwaz" /> Perfil recibido
      </motion.span>

      <div className="mt-5" data-id="element-70" data-mp="qdnxpqxlky2d">
        <Headline data-id="element-71" data-mp="v6pfq7t3pdq6">Ahora comienza la magia ✨</Headline>
        <Subtext data-id="element-72" data-mp="v6z3rpul5at8">
          Ya tenemos todo lo necesario para crear las 5 experiencias personalizadas de {childName}.
        </Subtext>
      </div>

      <ol className="mt-7 rounded-4xl border border-lavender-200 bg-white/90 p-5 shadow-soft" data-id="element-73" data-mp="2i1ozwpl1w58">
        {TIMELINE.map((item, index) => <motion.li key={item.label} initial={{
        opacity: 0,
        x: -8
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.12 * index,
        duration: 0.35
      }} className="flex items-center gap-3 py-2" data-id="element-74" data-mp="7ho308d8jgf3" data-mpi={index}>
            <span aria-hidden="true" className={`grid h-6 w-6 shrink-0 place-items-center rounded-full text-[11px] font-bold ${item.state === 'done' ? 'bg-violet-600 text-white' : item.state === 'active' ? 'border-2 border-violet-500 bg-violet-500/15 text-violet-600' : 'border border-lavender-200 text-transparent'}`} data-id="element-75" data-mp="1nvnztagsapy4">
              {item.state === 'done' ? <CheckIcon className="h-3.5 w-3.5" data-id="element-76" data-mp="3syft1d0jce1q" /> : '●'}
            </span>
            <span className={`text-[15px] ${item.state === 'todo' ? 'text-ink-muted' : 'font-semibold text-ink'}`} data-id="element-77" data-mp="3sx4ld23yym5c">
              {item.label}
            </span>
          </motion.li>)}
      </ol>

      <p className="mt-6 text-[15px] leading-relaxed text-ink-soft" data-id="element-78" data-mp="3f0r7e2yn92vm">
        Recibirás todo en el correo que utilizaste para acceder
        {email ? <>
            : <span className="font-semibold text-ink" data-id="element-79" data-mp="2mi3psxiuw5za">{email}</span>
          </> : '.'}
      </p>
      <p className="mt-1 text-[13px] text-ink-muted" data-id="element-80" data-mp="2hj99c28d2tic">Tiempo estimado: 3 a 5 días hábiles.</p>

      <div className="mt-6 rounded-4xl border border-gold-200 bg-gold-200/30 p-5 text-[15px] leading-relaxed text-ink" data-id="element-81" data-mp="x0yh7k4w1t4i">
        Ya no necesitas hacer nada más.
        <br data-id="element-82" data-mp="o1bl9duxhfiu" />
        Nosotros nos encargamos del resto 💜
      </div>

      <div className="mt-7" data-id="element-83" data-mp="nz8o89vcym4m">
        <PrimaryButton onClick={onFinish} data-id="element-84" data-mp="szmxtwcly44r">Finalizar</PrimaryButton>
      </div>
    </ScreenShell>;
}